import React, { useState, useEffect } from "react";

import { Col, Row,  Label } from "reactstrap";

import Select from "react-select";

import ContactoAddModal from "../../../Contacts/components/modals/ContactAddModal";
import "./style/casosAdd.scss";

import {  getContactsFilter, getContactsList } from "../../../../helpers/backend";

const ContactoForm = (props) => {
 
  const [crearModal, setCrearModal] = useState(false);
  const [inputSearch, setInputSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [contacts, setContacts] = useState([]);
  const handleCasoClick = (selected) => {
    setCrearModal(true);
  };

  console.log(props)
  const handleCloseModal = () => {
    setCrearModal(false);
  };


  const getContactData = async () => {
    try {
      const response = await getContactsList();
      setContacts(response.data.results?.data);
    
    } catch (error) {
      console.error("Error al obtener los contactos:", error);
    }
  };
  const handleFilter = async (params) => {
    try {
      const response = await getContactsFilter(params);
      if (response && response.data) {
        setContacts(response.data.results?.data);
   
      }
    } catch (error) {
      console.error("Error en handleFilter:", error);
    }
  };

  useEffect(() => {
    getContactData();
  }, []);



  const onSearch = (searchTerm) => {
    setInputSearch(true);
    setSearchTerm(searchTerm);
    handleFilter({ changeUrl: `?search=${searchTerm}` });
  };
  return (
    <React.Fragment>
      {crearModal ? (
        <ContactoAddModal
          style={{ overflow: "auto", zIndex: "100" }}
          crearModal={crearModal}
          onCloseClick={handleCloseModal}
        ></ContactoAddModal>
      ) : null}

      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label for="accountlist" className="col-form-label col-sm-4 d-flex">
            <strong>CONTACTO</strong>
            <span
              className="bx bx-user-plus fa-lg align-middle btn-add"
              onClick={() => handleCasoClick()}
            ></span>
          </Label>

          <Select
  id="accountlist"
  name="accountlist"
  placeholder="Seleccione"
  onChange={props.handleSelectContacto} // Usa la función combinada
  options={
    Array.isArray(contacts) 
      ? contacts.map((item) => ({
          label: item.first_name ? item.first_name : item.razon_social,
          value: item.id,
        }))
      : [] // Este es el arreglo vacío si contacts no es un array
  }
  onInputChange={(inputValue) => {
    onSearch(inputValue);
    if (inputValue === "") {
      setInputSearch(false);
    } else {
      setInputSearch(true);
    }
  }}
/>

        </Col>

        <Col md={6} className="mb-3">
          <Label for="tipo_visita" className="form-label mt-2">
          <strong>TIPO DE VISITA </strong>
          </Label>
          <Select
            id="tipo_visita"
            name="tipo_visita"
            options={props.TipoVisita}
            onChange={props.handleSelectTipoVisita}

            autoFocus
          />
          {/* 
{props.error && props.error.tipo_visita ? (
                              <Alert color = 'danger' className="mt-2">{props.error.tipo_visita}</Alert>
                              ):null} */}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ContactoForm;
